<template>
  <div>
    <div v-if="show_filter" class="ml-5 mr-5 mt-3 mb-3">
      <h3>{{ $t('dexpara.filtros.titulo') }}</h3>
      <div class="row">
        <b-form-group :label="$t('dexpara.filtros.nome')" label-for="input-nome" class="col-md-3">
          <b-form-input id="input-nome" v-model="filters.name" @change="evt => setFilter('name', evt)" @keyup.enter="e=>{e.preventDefault(); $emit('search')}"/>
        </b-form-group>
        <b-form-group :label="$t('dexpara.filtros.codigo')" label-for="input-codigo" class="col-md-3">
          <b-form-input id="input-codigo" v-model="filters.code" @change="evt => setFilter('code', evt)" @keyup.enter="e=>{e.preventDefault(); $emit('search')}"/>
        </b-form-group>
        <b-form-group :label="$t('dexpara.filtros.componente')" label-for="input-componente" class="col-md-3">
          <SelectComponent
              id="input-componente"
              :options="components | idNameToValueLabel"
              :searching="store_components_isLoading"
              @search="evt => autocomplete('tuevs/component/search', evt)"
              @input="evt => setFilter('component', evt)"
          />
        </b-form-group>
        <b-form-group :label="$t('dexpara.filtros.material')" label-for="input-material" class="col-md-3">
          <SelectComponent
              id="input-material"
              :options="materials | idNameToValueLabel"
              :searching="store_materials_isLoading"
              @search="evt => autocomplete('tuevs/material/search', evt)"
              @input="evt => setFilter('specimen', evt)"
          />
        </b-form-group>
        <b-form-group :label="$t('dexpara.filtros.metodo')" label-for="input-metodo" class="col-md-3">
          <SelectComponent
              id="input-metodo"
              :options="methods | idNameToValueLabel"
              :searching="store_methods_isLoading"
              @search="evt => autocomplete('tuevs/method/search', evt)"
              @input="evt => setFilter('method', evt)"
          />
        </b-form-group>
        <b-form-group :label="$t('dexpara.filtros.tempos')" label-for="input-tempos" class="col-md-3">
          <SelectComponent
              id="input-tempos"
              :options="times | idNameToValueLabel"
              :searching="store_times_isLoading"
              @search="evt => autocomplete('tuevs/time/search', evt)"
              @input="evt => setFilter('time', evt)"
          />
        </b-form-group>
        <b-form-group :label="$t('dexpara.filtros.escala')" label-for="input-escala" class="col-md-3">
          <SelectComponent
              id="input-escala"
              :searching="store_scales_isLoading"
              :options="scales | idNameToValueLabel"
              @search="evt => autocomplete('tuevs/scale/search', evt)"
              @input="evt => setFilter('scale', evt)"
          />
        </b-form-group>
        <b-form-group :label="$t('dexpara.filtros.integracao')" label-for="input-integracao" class="col-md-3">
          <SelectComponent
              id="input-integracao"
              :searching="store_integrations_isLoading"
              :options="integrations | idNameToValueLabel"
              @search="evt => autocomplete('integration/search', evt)"
              @input="evt => setFilter('integration', evt)"
          />
        </b-form-group>
        <div class="col-md-3 d-flex align-items-center">
          <b-button id="btn-filter" variant="primary" class="w-100 mt-3" @click="$emit('search')">
            <i class="fas fa-search mr-2"/> {{ $t('dexpara.filtros.botao_filtrar') }}
          </b-button>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <b-link id="hide-filters" class="m-auto" @click="show_filter = !show_filter">{{ $t('dexpara.filtros.esconder_filtros') }}</b-link>
      </div>
    </div>
    <div v-else class="w-75 text-center ml-auto mr-auto">
      <b-link id="show-filters" @click="show_filter = !show_filter">{{ $t('dexpara.filtros.mostrar_filtros') }}</b-link>
    </div>
  </div>
</template>

<script>
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "DeXParaFilter",
  components: {SelectComponent},
  computed: {
    ...mapGetters({
      components: 'tuevs/component/all',
      store_components_isLoading: 'tuevs/component/isLoading',
      materials: 'tuevs/material/all',
      store_materials_isLoading: 'tuevs/material/isLoading',
      methods: 'tuevs/method/all',
      store_methods_isLoading: 'tuevs/method/isLoading',
      times: 'tuevs/time/all',
      store_times_isLoading: 'tuevs/time/isLoading',
      scales: 'tuevs/scale/all',
      store_scales_isLoading: 'tuevs/scale/isLoading',
      integrations: 'integration/all',
      store_integrations_isLoading: 'integration/isLoading',
    })
  },
  data() {
    return {
      show_filter: false,
      awaitingSearch: false,
      filters: {
        name: null,
        code: null,
        component: null,
        specimen: null,
        method: null,
        time: null,
        scale: null,
        integration: null
      }
    }
  },
  methods: {
    ...mapActions([
      'tuevs/component/search',
      'tuevs/material/search',
      'tuevs/method/search',
      'tuevs/time/search',
      'tuevs/scale/search',
      'integration/search'
    ]),
    autocomplete(action, string) {
      if (string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
          this.temporallyStringPrepareToSQL('name', string).map(array => {
            this[action]({filters: [array]})
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    temporallyStringPrepareToSQL(field, valueTyped) {
      return [
        [field, 'LIKE', '%' + valueTyped.toUpperCase() + '%'],
        [field, 'LIKE', '%' + valueTyped.toLowerCase() + '%'],
        [field, 'LIKE', '%' + valueTyped.charAt(0).toUpperCase() + valueTyped.slice(1) + '%'],
      ]
    },
    setFilter(key, value) {
      this.filters[key] = value
      if (value && value.value) {
        this.filters[key] = value.value
      }
      this.sanitizeFilters()
    },
    sanitizeFilters() {
      let sanitizedFilters = []
      for (var [key, value] of Object.entries(this.filters)) {
        if (value) {
          if (key === 'name') {
            sanitizedFilters = [...sanitizedFilters, [key, 'LIKE', '%' + value + '%']]
            continue;
          }

          sanitizedFilters = [...sanitizedFilters, [key, '=', value]]
        }
      }
      this.$store.commit('dexpara/setFilters', sanitizedFilters)
    }
  },
  mounted() {
    Object.keys(this.filters).map(field => {
      this.setFilter(field, null)
    })
    this.setFilter('status', true)
    this['tuevs/component/search']()
    this['tuevs/material/search']()
    this['tuevs/method/search']()
    this['tuevs/time/search']()
    this['tuevs/scale/search']()
  }
}
</script>

<style lang="scss" scoped>
</style>
